import { ProtectionGoal } from './context/protection-goal/entity';

export const protectionGoals: ProtectionGoal[] = [
    ProtectionGoal.new({
        name: 'Confidentiality',
        capabilities: 'Configuration, passwords, customer/user information',
    }),
    ProtectionGoal.new({
        name: 'Integrity',
        capabilities:
            'Network configurations, data storage/archive, communication data, process data',
    }),
    ProtectionGoal.new({
        name: 'Availability',
        capabilities: 'Network connections, system power',
    }),
    ProtectionGoal.new({
        name: 'Safety',
        capabilities:
            'Fire & gas applications, maximum speed set points, maximum energy output',
    }),
];
